/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action from '../application-actions.js';

import ProductStore from '../store/product-store.js';

class ProductService {
    getAllLanguages(force) {

        if (ProductStore.getLanguages().length > 0 && !force) {
            return new Promise(function (resolve) { resolve() })
        }

        return ApplicationServices.call(Constants.GET_LANGUAGES, {}).then(function (response) {
            Action.update(Constants.GET_LANGUAGES, response);
            return response.success
        })
    }

    getUserData() {
        return ApplicationServices.call(Constants.GET_USER_DATA,
            {}).then(function (response) {
                Action.update(Constants.GET_USER_DATA, response);
                return response.success
            })
    }

    getVideoData() {
        return ApplicationServices.call(Constants.GET_VIDEO_DATA,
            {}).then(function (response) {
                Action.update(Constants.GET_VIDEO_DATA, response);
                return response.success
            })
    }

    getAllAdditionalCurriculums() {
        return ApplicationServices.call(Constants.GET_ADDITIONAL_CURRICULUM,
            {}).then(function (response) {
                Action.update(Constants.GET_ADDITIONAL_CURRICULUM, response.additionalCurriculums);
                return response.additionalCurriculums
            })
    }

    getSharedAdditionalCurriculums() {
        return ApplicationServices.call(Constants.GET_SHARED_CURRICULUM,
            {}).then(function (response) {
                Action.update(Constants.GET_SHARED_CURRICULUM, response.additionalCurriculums);
                return response.additionalCurriculums
            })
    }

    getTeacherScreen(language) {
        return ApplicationServices.call(Constants.GET_TEACHER_SCREEN,
            { ietf: language.ietf }).then(function (response) {
                return response.screenUid
            })
    }

    setAccountCurriculums(curriculums) {
        return ApplicationServices.call(Constants.SET_ADDITIONAL_CURRICULUM,
            { curriculums: curriculums }).then(function (response) {
                Action.update(Constants.SET_ADDITIONAL_CURRICULUM, response);
                return response.success
            })
    }

    setAccountCurriculumsClass(curriculums, classUid) {
        return ApplicationServices.call(Constants.SET_ADDITIONAL_CURRICULUM,
            { curriculums: curriculums, classUid: classUid }).then(function (response) {
                Action.update(Constants.SET_ADDITIONAL_CURRICULUM, response);
                return response.success
            })
    }
}

export default new ProductService();